/** EditOpportunityFooter.jsx - the editor's action bar (delete / comment / cancel / save). */
import { BTN_CANCEL, BTN_PRIMARY } from './editOpportunityConstants';

const OFF = { opacity: 0.55, cursor: 'not-allowed' };

// `noun` names the record on the create button ('Opportunity' or 'Project');
// `closeLabel` is the button that leaves without saving (Cancel in a pop-up,
// Back to Projects on a project's page). `saving`: a save is on its way - the
// button says so and is disabled, and so are Cancel and Delete (10/13/26: a
// click during a slow save was silently ignored, which read as "not saved").
// `extra` sits on the left after Delete (the Build quote button, 10/20/26 - its
// own bar above the footer cost the pop-up a row of height).
export function renderFooter({
  canDelete,
  editable,
  handleDelete,
  handleSave,
  onClose,
  isCreate,
  onComment,
  commentCount,
  noun = 'Opportunity',
  closeLabel = 'Cancel',
  saving = false,
  extra = null,
}) {
  return (
    <div
      style={{
        padding: '10px 24px',
        flexShrink: 0,
        borderTop: '1px solid #ECECEC',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10,
        background: '#fff',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
        {canDelete && (
          <button
            onClick={handleDelete}
            disabled={saving}
            style={{
              background: '#fff',
              color: '#B71C1C',
              border: '1px solid #FFCDD2',
              padding: '9px 18px',
              borderRadius: 6,
              fontWeight: 700,
              fontSize: 11,
              cursor: 'pointer',
              fontFamily: 'Montserrat',
              ...(saving ? OFF : {}),
            }}
          >
            Delete
          </button>
        )}
        {extra}
      </div>
      <div style={{ display: 'flex', gap: 10, flexShrink: 0 }}>
        {!isCreate && (
          <button
            onClick={onComment}
            title="Comments"
            style={{
              background: '#fff',
              color: '#1B5E20',
              border: '1px solid #C8E6C9',
              padding: '9px 18px',
              borderRadius: 6,
              fontWeight: 700,
              fontSize: 11,
              cursor: 'pointer',
              fontFamily: 'Montserrat',
            }}
          >
            💬 Comment{commentCount ? ` (${commentCount})` : ''}
          </button>
        )}
        <button onClick={onClose} disabled={saving} style={{ ...BTN_CANCEL, ...(saving ? OFF : {}) }}>
          {closeLabel}
        </button>
        {editable && (
          // No focus change on mousedown, so a Customer still being typed is
          // not blurred: the "Add ... as a new customer?" confirm that blur
          // opened swallowed this click in Chrome. handleSave settles it
          // instead (r49 fix F6). Tab + Enter still blurs it as before.
          <button
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleSave}
            disabled={saving}
            aria-busy={saving || undefined}
            style={{
              ...BTN_PRIMARY,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
              ...(saving ? { cursor: 'progress', opacity: 0.85 } : {}),
            }}
          >
            {saving && <span className="go-spin" aria-hidden="true" />}
            {saving ? 'Saving…' : isCreate ? `Create ${noun}` : 'Save Changes'}
          </button>
        )}
      </div>
    </div>
  );
}
